import { Box, Stack, Typography } from '@mui/material';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    action?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, action }) => (
    <Stack
        direction="row"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        spacing={2}
        sx={{ width: '100%', minWidth: 0, mb: { xs: 3, md: 4 } }}
    >
        <Box sx={{ minWidth: 0 }}>
            <Typography
                sx={{
                    fontFamily: 'Georgia, "Times New Roman", serif',
                    fontWeight: 700,
                    fontSize: { xs: 28, md: 36 },
                    lineHeight: 1.1,
                    color: 'var(--pvta-green-900)',
                }}
            >
                {title}
            </Typography>
            {subtitle && (
                <Typography variant="body1" sx={{ color: 'var(--pvta-muted)', mt: 0.75 }}>
                    {subtitle}
                </Typography>
            )}
        </Box>
        {action && (
            <Box sx={{ flexShrink: 0 }}>
                {action}
            </Box>
        )}
    </Stack>
);

export default PageHeader;
